import React from 'react';
import Icon from '@ant-design/icons';

const InfoSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_22531_48221)">
      <path
        d="M7.9987 14.6668C11.6806 14.6668 14.6654 11.6821 14.6654 8.00016C14.6654 4.31826 11.6806 1.3335 7.9987 1.3335C4.3168 1.3335 1.33203 4.31826 1.33203 8.00016C1.33203 11.6821 4.3168 14.6668 7.9987 14.6668Z"
        stroke="#4F4E7B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 10.6667V8" stroke="#4F4E7B" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 5.3335H8.00667" stroke="#4F4E7B" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_22531_48221">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const InfoIcon2 = (props) => <Icon component={InfoSvg} {...props} />;

export default InfoIcon2;
